// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1kmrn","productName":"Table_productName__3CDpf"};